export default __webpack_public_path__ + "static/media/basket.be3131df.svg";